import { isAxiosError } from "axios";
import axiosInstance from "./axiosIntercept";
import { Wizard, WizardSummary } from "../features/wizard-cms/types";

const apiUrl = `${process.env.REACT_APP_API_URL}v1/wizardCMS`;

export const getWizards = async (): Promise<WizardSummary[]> => {
  console.log("Fetching all wizards...");
  try {
    const response = await axiosInstance.get<WizardSummary[]>(apiUrl, {
      withCredentials: true,
      headers: { "api-key": process.env.REACT_APP_API_KEY },
    });
    console.log("Fetched wizards:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching wizards:",
      isAxiosError(error) ? error.response : error,
    );
    throw error;
  }
};

export const getWizardById = async (wizardId: string): Promise<Wizard> => {
  console.log(`Fetching wizard with ID: ${wizardId}`);
  try {
    const response = await axiosInstance.get<Wizard>(`${apiUrl}/${wizardId}`, {
      withCredentials: true,
      headers: { "api-key": process.env.REACT_APP_API_KEY },
    });
    console.log(`Fetched wizard ${wizardId}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(
      `Error fetching wizard ${wizardId}:`,
      isAxiosError(error) ? error.response : error,
    );
    throw error;
  }
};

export const createWizard = async (wizardData: Wizard): Promise<Wizard> => {
  console.log("Creating new wizard with data:", wizardData);
  try {
    const response = await axiosInstance.put<Wizard>(
      `${apiUrl}/create-or-update`,
      wizardData,
      {
        withCredentials: true,
        headers: {
          "api-key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
      },
    );
    console.log("Successfully created wizard:", response.data);
    return response.data;
  } catch (error) {
    console.error(
      "Error creating wizard:",
      isAxiosError(error) ? error.response : error,
    );
    throw error;
  }
};

export const updateWizard = async (
  wizardId: string,
  wizardData: Pick<Wizard, "name" | "content">,
): Promise<Wizard> => {
  console.log(`Updating wizard ${wizardId} with data:`, wizardData);
  try {
    const response = await axiosInstance.put<Wizard>(
      `${apiUrl}/${wizardId}`,
      wizardData,
      {
        withCredentials: true,
        headers: {
          "api-key": process.env.REACT_APP_API_KEY,
          "Content-Type": "application/json",
        },
      },
    );
    console.log(`Successfully updated wizard ${wizardId}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(
      `Error updating wizard ${wizardId}:`,
      isAxiosError(error) ? error.response : error,
    );
    throw error;
  }
};

export const deleteWizard = async (wizardId: string): Promise<void> => {
  console.log(`Deleting wizard with ID: ${wizardId}`);
  try {
    await axiosInstance.delete(`${apiUrl}/${wizardId}`, {
      withCredentials: true,
      headers: { "api-key": process.env.REACT_APP_API_KEY },
    });
    console.log(`Successfully deleted wizard ${wizardId}`);
  } catch (error) {
    console.error(
      `Error deleting wizard ${wizardId}:`,
      isAxiosError(error) ? error.response : error,
    );
    throw error;
  }
};
